export const Logo = ({ compact = false }) => (
  <span data-testid="brand-logo" className="inline-flex items-center">
    <img
      src="/orego-logo-dark.png"
      alt="Orego Tours"
      className={`object-contain ${compact ? "h-14" : "h-20"} w-auto drop-shadow-[0_2px_10px_rgba(0,0,0,0.5)]`}
    />
  </span>
);

export default Logo;
